import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const ITEMS = [
  { label: "OBRAS", to: "/obras" },
  { label: "SERVICIOS", to: "/#servicios" },
  { label: "ESTUDIO", to: "/#estudio" },
  { label: "CONTACTO", to: "/#contacto" },
];

export const Menu = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const go = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      const hash = to.slice(1);
      if (location.pathname === "/") {
        setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 350);
      } else {
        navigate("/" + hash);
      }
    } else {
      navigate(to);
    }
  };

  return (
    <>
      <Link to="/" data-testid="header-logo" aria-label="Sebastián Ferradás Rosso — Arquitecto" className="fixed top-6 left-6 md:left-10 z-[60] block">
        <img src="/logo-sfr.png" alt="Sebastián Ferradás Rosso · Arquitecto" className="w-[110px] max-w-[110px] h-auto object-contain select-none" draggable="false" />
      </Link>

      <button
        data-testid="menu-toggle-button"
        onClick={() => setOpen(!open)}
        aria-label={open ? "Cerrar menú" : "Abrir menú"}
        className="fixed top-6 right-6 md:right-10 z-[70] w-12 h-12 flex flex-col items-end justify-center gap-[7px] group"
      >
        <span className={`block h-[2px] transition-all duration-300 ${open ? "w-8 bg-[#111111] rotate-45 translate-y-[4.5px]" : "w-8 bg-white drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)] group-hover:bg-[#D94A1E]"}`} />
        <span className={`block h-[2px] transition-all duration-300 ${open ? "w-8 bg-[#111111] -rotate-45 -translate-y-[4.5px]" : "w-5 bg-white drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)] group-hover:w-8 group-hover:bg-[#D94A1E]"}`} />
      </button>

      <div
        data-testid="menu-overlay"
        className={`fixed inset-y-0 right-0 z-[65] w-full md:w-[55vw] lg:w-[45vw] bg-[#D94A1E] flex flex-col justify-center transition-all duration-[350ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${open ? "translate-x-0 opacity-100" : "translate-x-full opacity-0 pointer-events-none"}`}
      >
        <nav className="px-8 md:px-14">
          <div className="border-t border-[#111111]" />
          {ITEMS.map((item) => (
            <div key={item.label} className="border-b border-[#111111]">
              <button
                data-testid={`menu-item-${item.label.toLowerCase()}`}
                onClick={() => go(item.to)}
                className="menu-item block w-full text-left py-5 md:py-7 text-4xl md:text-6xl lg:text-7xl font-medium uppercase tracking-tight text-[#111111]"
              >
                {item.label}
              </button>
            </div>
          ))}
        </nav>
        <p className="px-8 md:px-14 mt-10 text-sm text-[#111111]/80 max-w-sm">
          Arquitectura, diseño y gestión de proyectos para hotelería, centros comerciales y vivienda.
        </p>
      </div>
    </>
  );
};
